import { i18n } from '@aqx-core/common/i18n';

import { ECompanyExposureSymbolType } from './types';

export const SYMBOL_TYPE_OPTIONS = [
  { value: ECompanyExposureSymbolType.FOREX, label: () => i18n.t('Forex') },
  { value: ECompanyExposureSymbolType.INDEX, label: () => i18n.t('Indices') },
  { value: ECompanyExposureSymbolType.CRYPTO, label: () => i18n.t('Crypto') },
  { value: ECompanyExposureSymbolType.SHARE, label: () => i18n.t('Shares') },
  { value: ECompanyExposureSymbolType.COM, label: () => i18n.t('Commodities') }
];

export const DEFAULT_SYMBOL_TYPES = SYMBOL_TYPE_OPTIONS.map((option) => option.value);

export const DEFAULT_PAGE_SIZE = 30;
